import { BuildingCircularSiteMenuList } from "../utils/constants";
import { TableStructure } from "../components/TableStructure";

const Building_Sanction_Circular_2014_15 = () => (
  <TableStructure
    list={[
      {
        date: "16/09/2014",
        subject: "KMDA Development Charge with 500 m of EM Bye Pass",
        fileStoreId: "178ca8ca-e8cc-4ae8-a58e-c3230b907165",
        label: "DG(BLDG)'s Circular No. 9 of 2014-15",
      },
      {
        date: "29/08/2014",
        subject: "Drainage development charges in JOKA",
        fileStoreId: "0e9589c5-13db-4148-a1e0-9b58061553d3",
        label: "DG(BLDG)'s Circular No. 7 of 2014-15",
      },
      {
        date: "04/08/2014",
        subject:
          "CC plan to forward Assessment Dept and AutoCAD file for floor area more than 20000 Sqm",
        fileStoreId: "2ee8cf63-046d-4384-8165-5f4bcb2a75c6",
        label: "DG(BLDG)'s Circular No. 6 of 2014-15",
      },
      {
        date: "10/07/2014",
        subject:
          "Affidavit format for demolition consent of tenants in rule 142",
        fileStoreId: "6f461575-fcd8-45d3-9c84-18b26e357422",
        label: "DG(BLDG)'s Circular No. 5 of 2014-15",
      },
      {
        date: "06/06/2014",
        subject:
          "Assessment report required where BLRO mutation is not submitted but mutated in KMC before 24/04/2014 for Br-XII",
        fileStoreId: "b760825d-2a26-4fe3-b5d1-d9265a40cd97",
        label: "DG(BLDG)'s Circular No. 3 of 2014-15",
      },
      {
        date: "03/06/2014",
        subject: "Acceptence of proposal on KoPT land",
        fileStoreId: "0673d9db-814b-4942-9fd7-fe1b46bb2c9e",
        label: "DG(BLDG)'s Circular No. 2 of 2014-15",
      },
      {
        date: "23/05/2014",
        subject:
          "KIT observation is mandetory and Office order no 27 of 2009-2010 dated 22/03/2010 is repealed",
        fileStoreId: "012113d7-7cef-48b0-bdcf-99cbe4328122",
        label: "DG(BLDG)'s Circular No. 1 of 2014-15",
      },
    ]}
    columnNo={3}
    leftMenuList={BuildingCircularSiteMenuList}
    title="Circular :: 2014-15"
    longMenuList={true}
  />
);

export default Building_Sanction_Circular_2014_15;
